import type { ITagRelations } from '@dakedake/types'
import { request } from '@umijs/max'

/** 获取关联详情 GET /backend/tagRelations/:id */
export async function tagRelationsDetail(options?: Record<string, any>) {
  return request<{ data: ITagRelations }>('/backend/tagRelations/:id', {
    method: 'GET',
    ...options
  })
}

/** 获取关联产品列表 GET /backend/tagRelations/list */
export async function tagRelationsList(params: { sid?: number, aid?: number }) {
  return request<{ data: ITagRelations[] }>('/backend/tagRelations/list', {
    method: 'GET',
    params: {
      ...params
    }
  })
}

/** 添加/编辑关联产品 POST /api/tagRelations/add */
export async function tagRelationsAdd(body: ITagRelations) {
  return request<{ data: ITagRelations, status: number, message: string }>('/backend/tagRelations/add', {
    method: 'POST',
    data: body
  })
}

/** 删除关联产品 DELETE /api/tagRelations/delete */
export async function tagRelationsDelete(body: { id?: number }) {
  return request<{ data: number }>('/backend/tagRelations/delete', {
    method: 'DELETE',
    data: body
  })
}
